export const initialState = {
  diseases: [],
  disease: {},
  filters: {}
};
